import React from "react";
import { animated, useSpring } from "@react-spring/web";

const Loader = () => {

    const scaleFactor = 1.1;
    const translateFactor = "15px";

    const baseAnimation = {
        from: { opacity: 0, transform: `translateY(${translateFactor}) scale(${scaleFactor})` }, // Assume the height of the element is 100%, thus 25% for the adjustment
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        to: async (next) => {
            // eslint-disable-next-line no-constant-condition
            while (1) {
                await next({ opacity: 1, transform: `translateY(${translateFactor}) scale(1)` });
                await next({ opacity: 0, transform: `translateY(${translateFactor}) scale(1)` });
                await next({ opacity: 0, transform: `translateY(${translateFactor}) scale(${scaleFactor})` });
            }
        },
        // config: { tension: 150, friction: 21 },
    }

    // s[n], where n denotes the row number
    // s[n]i[x], where x denotes the column number

    const s1i1 = useSpring({ ...baseAnimation, delay: 200 });
    const s1 = useSpring({ ...baseAnimation, delay: 300 });
    const s2i1 = useSpring({ ...baseAnimation, delay: 400 });
    const s2 = useSpring({ ...baseAnimation, delay: 500 });
    const s3i1 = useSpring({ ...baseAnimation, delay: 600 });
    const s3 = useSpring({ ...baseAnimation, delay: 700 });
    const s4i1 = useSpring({ ...baseAnimation, delay: 800 });
    const s4 = useSpring({ ...baseAnimation, delay: 900 });
    const s5i1 = useSpring({ ...baseAnimation, delay: 1000 });
    const s5i2 = useSpring({ ...baseAnimation, delay: 1100 });
    const s5 = useSpring({ ...baseAnimation, delay: 1200 });
    const s6i1 = useSpring({ ...baseAnimation, delay: 1300 });
    const s6i2 = useSpring({ ...baseAnimation, delay: 1400 });
    const s6 = useSpring({ ...baseAnimation, delay: 1500 });
    // s5i1, s5i2

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", maxHeight: "550px", marginLeft: "-100px", transform: "scale(0.4)" }}>
            <svg
                version="1.1"
                id="svg2"
                xmlSpace="preserve"
                width="552.22668"
                height="615.8667"
                viewBox="0 0 552.22668 615.8667"
                xmlns="http://www.w3.org/2000/svg"><g
                    id="g8"
                    transform="matrix(1.3333333,0,0,-1.3333333,0,615.86667)"><g
                        id="g24"
                        clipPath="none"
                        transform="scale(0.1)">

                        <animated.path
                            id="path34"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s1i1, transformOrigin: "center" }}
                            d="m 1821.1084,4566.9982 c -24.0799,0 -43.7841,-19.7089 -43.7841,-43.7988 v -631.3038 c 0,-24.0899 19.7042,-43.7842 43.7841,-43.7842 h 631.3477 c 2.6342,0 5.1956,0.325 7.7051,0.7764 l -452.2559,718.1104 z"
                        />

                        <animated.path
                            id="path36"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s1, transformOrigin: "center" }}
                            d="m 1038.1055,4566.9982 c -12.3838,0 -23.552,-5.2591 -31.5381,-13.5938 l 471.6504,-705.293 h 191.1621 c 24.09,0 43.7842,19.6943 43.7842,43.7842 v 631.3038 c 0,24.0899 -19.6942,43.7988 -43.7842,43.7988 z"
                        />

                        <animated.path
                            id="path42"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s2i1, transformOrigin: "center" }}
                            d="m 1821.1084,3780.2452 c -24.0799,0 -43.7841,-19.7088 -43.7841,-43.7988 v -335.5957 l 227.1093,-339.624 h 448.0225 c 24.08,0 43.7988,19.7088 43.7988,43.7988 v 631.4209 c 0,24.09 -19.7188,43.7988 -43.7988,43.7988 z"
                        />

                        <animated.path
                            id="path44"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s2, transformOrigin: "center" }}
                            d="m 1523.6133,3780.2452 189.5508,-283.4619 v 239.6631 c 0,24.09 -19.6942,43.7988 -43.7842,43.7988 z"
                        />

                        <animated.path
                            id="path50"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s3i1, transformOrigin: "center" }}
                            d="m 1965.0733,2993.3751 -187.749,-286.0107 V 2318.17 c 0,-24.09 19.7042,-43.7842 43.7841,-43.7842 h 621.7676 l 53.3789,85.2686 v 589.9219 c 0,24.0899 -19.7188,43.7988 -43.7988,43.7988 z"
                        />

                        <animated.path
                            id="path52"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s3, transformOrigin: "center" }}
                            d="M 1713.1641,2609.63 1493.086,2274.3858 h 176.2939 c 24.09,0 43.7842,19.6942 43.7842,43.7842 z"
                        />

                        <animated.path
                            id="path58"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s5, transformOrigin: "center" }}
                            d="M 920.72756,1402.5255 459.9463,700.6309 h 426.50392 c 24.08597,0 43.78418,19.70221 43.78418,43.78418 v 631.23052 c 0,10.1616 -3.64429,19.4296 -9.50684,26.8799 z"
                        />

                        <animated.path
                            id="path62"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s4, transformOrigin: "center" }}
                            d="M 1448.3789,2206.2999 996.56252,1518.043 c 5.64878,-17.6603 22.06648,-30.6299 41.54298,-30.6299 h 631.2744 c 24.09,0 43.7842,19.7043 43.7842,43.7842 v 631.3184 c 0,24.09 -19.6942,43.7842 -43.7842,43.7842 z"
                        />

                        <animated.path
                            id="path64"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s4i1, transformOrigin: "center" }}
                            d="m 1821.1084,2206.2999 c -24.0799,0 -43.7841,-19.6942 -43.7841,-43.7842 v -631.3184 c 0,-24.0799 19.7042,-43.7842 43.7841,-43.7842 h 129.126 l 450.0147,718.8868 z"
                        />

                        <animated.path
                            id="path66"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s5i2, transformOrigin: "center" }}
                            d="m 1821.1084,1419.4444 c -24.0799,0 -43.7841,-19.7089 -43.7841,-43.7988 v -164.458 l 130.3711,208.2568 z"
                        />

                        <animated.path
                            id="path68"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s5i1, transformOrigin: "center" }}
                            d="m 1038.1055,1419.4444 c -24.09,0 -43.79883,-19.7089 -43.79883,-43.7988 V 744.41508 c 0,-24.08197 19.70883,-43.78418 43.79883,-43.78418 h 419.6191 l 255.4395,408.0615 v 266.9532 c 0,24.0899 -19.6942,43.7988 -43.7842,43.7988 z"
                        />

                        <animated.path
                            id="path70"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s6i2, transformOrigin: "center" }}
                            d="M 415.34181,632.69145 211.24512,321.77835 V -0.00388125 H 930.2344 V 588.90727 c 0,24.07797 -19.69821,43.78418 -43.78418,43.78418 z"
                        />

                        <animated.path
                            id="path72"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s6, transformOrigin: "center" }}
                            d="M 146.89453,223.76566 0,-0.00388125 h 146.89453 z"
                        />

                        <animated.path
                            id="path76"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s6i1, transformOrigin: "center" }}
                            d="m 1038.1055,632.69145 c -24.09,0 -43.79883,-19.70621 -43.79883,-43.78418 V -0.00388125 h 24.82913 L 1415.2002,632.69145 Z"
                        />

                        <animated.path
                            id="path78"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s4i1, transformOrigin: "center" }}
                            d="m 2642.4024,2206.2999 456.2403,-718.8868 h 136.8457 c 24.0899,0 43.7988,19.7043 43.7988,43.7842 v 631.3184 c 0,24.09 -19.7089,43.7842 -43.7988,43.7842 z"
                        />

                        <animated.path
                            id="path80"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s4, transformOrigin: "center" }}
                            d="m 3387.4366,2206.2999 c -24.09,0 -43.7988,-19.6942 -43.7988,-43.7842 v -631.3184 c 0,-24.0799 19.7088,-43.7842 43.7988,-43.7842 h 631.4209 c 24.09,0 43.7989,19.7043 43.7989,43.7842 v 27.0117 l -434.5753,648.0909 z"
                        />

                        <animated.path
                            id="path96"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s1, transformOrigin: "center" }}
                            d="m 3387.4366,4566.9982 c -24.09,0 -43.7988,-19.7089 -43.7988,-43.7988 v -631.3038 c 0,-24.0899 19.7088,-43.7842 43.7988,-43.7842 h 189.9024 l 473.789,704.4141 c -8.0266,8.8213 -19.4774,14.4727 -32.2705,14.4727 z"
                        />

                        <animated.path
                            id="path98"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s1i1, transformOrigin: "center" }}
                            d="M 3072.9054,4566.9982 2616.709,3848.1114 h 618.7794 c 24.0899,0 43.7988,19.6943 43.7988,43.7842 v 631.3038 c 0,24.0899 -19.7089,43.7988 -43.7988,43.7988 z"
                        />

                        <animated.path
                            id="path102"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s2, transformOrigin: "center" }}
                            d="m 3387.4366,3780.2452 c -24.09,0 -43.7988,-19.7088 -43.7988,-43.7988 v -235.7959 l 188.0566,279.5947 z"
                        />

                        <animated.path
                            id="path104"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s2i1, transformOrigin: "center" }}
                            d="m 2604.1114,3780.2452 c -24.09,0 -43.7988,-19.7088 -43.7988,-43.7988 v -631.4209 c 0,-24.09 19.7088,-43.7988 43.7988,-43.7988 h 450.7031 l -3.3545,5.0097 227.8272,338.7305 v 331.4795 c 0,24.09 -19.7089,43.7988 -43.7988,43.7988 z"
                        />

                        <animated.path
                            id="path108"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s3, transformOrigin: "center" }}
                            d="M 3343.6378,2630.504 V 2318.17 c 0,-24.09 19.7088,-43.7842 43.7988,-43.7842 h 195 z"
                        />

                        <animated.path
                            id="path110"
                            style={{ fill: "#3663b2", fillOpacity: 1, fillRule: "nonzero", stroke: "none", ...s3i1, transformOrigin: "center" }}
                            d="m 2604.1114,2993.3751 c -24.09,0 -43.7988,-19.7089 -43.7988,-43.7988 v -613.9307 l 38.54,-60.7324 c 1.7433,-0.2133 3.4603,-0.5274 5.2588,-0.5274 h 631.377 c 24.0899,0 43.7988,19.6942 43.7988,43.7842 v 408.2959 l -178.9746,266.9092 z" /></g>
                </g>
            </svg>
        </div>
    )
}

export default Loader;